/**
 * @generated SignedSource<<89745ebd23bb50745710ba1bcc17f740>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShareInstanceProductListItemFragment$data = {
  readonly badge: {
    readonly " $fragmentSpreads": FragmentRefs<"BadgeFragment">;
  } | null;
  readonly id: string;
  readonly name: string;
  readonly productApps: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ShareInstanceAppListItemFragment">;
      };
    }>;
  };
  readonly " $fragmentType": "ShareInstanceProductListItemFragment";
};
export type ShareInstanceProductListItemFragment$key = {
  readonly " $data"?: ShareInstanceProductListItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShareInstanceProductListItemFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShareInstanceProductListItemFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Badge",
      "kind": "LinkedField",
      "name": "badge",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BadgeFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeNested",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "kinds",
          "value": [
            "collection",
            "curriculum"
          ]
        }
      ],
      "concreteType": "ProductAppNodeConnection",
      "kind": "LinkedField",
      "name": "productApps",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductAppNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductApp",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ShareInstanceAppListItemFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "productApps(includeNested:true,kinds:[\"collection\",\"curriculum\"])"
    }
  ],
  "type": "Product",
  "abstractKey": null
};
})();

(node as any).hash = "ad316d259d05c7bee36a7993213a1fa1";

export default node;
